// sidebar.service.ts
import { ENDPOINTS, getAuthUrl } from "./auth.config";

export class AuthService {
  static getToken(): string | null {
    if (typeof window === "undefined") return null;
    return localStorage.getItem("token");
  }

  static setToken(token: string): void {
    if (typeof window === "undefined") return;
    localStorage.setItem("token", token);
  }

  static clearToken(): void {
    if (typeof window === "undefined") return;
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    localStorage.removeItem("userRole");
  }

  static getUserId(): string | null {
    if (typeof window === "undefined") return null;
    return localStorage.getItem("userId");
  }

  static getUserRole(): string | null {
    if (typeof window === "undefined") return null;
    return localStorage.getItem("userRole");
  }

  static async userLogin(username: string, password: string) {
    try {
      const response = await fetch(getAuthUrl(ENDPOINTS.LOGIN), {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ username, password })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error("Login failed with status", response.status, "Response:", errorData);
        throw new Error(errorData.message || `Login failed with status ${response.status}`);
      }

      const data = await response.json();
      if (data.success && data.data?.accessToken) {
        this.setToken(data.data.accessToken);
        return data;
      }
      console.error("Login response missing token:", data);
      throw new Error(data.message || "Login failed - missing token");
    } catch (error) {
      console.error("Login error:", error);
      throw error;
    }
  }
}